/**
 * @flow
 */

import React, { Component } from 'react'
import Dropdown from '../../Dropdown'
import Colors from '../../../themes/Colors'
import {
  scrollToDesktopSBFormDropdown,
  enableScroll,
  disableScroll
} from '../../../utils/navigationUtils'
import {
  MainContainer,
  DropdownButton,
  DropdownValue,
  DropdownDownArrow,
  DownArrow,
  DropdownOptionsContainer,
  DropdownText,
  DropdownLabel,
  DropdownError,
  DropdownLeftIcon,
  LeftIcon
} from './styledComponents'
import styles from './styles'

type Props = {
  dropdownPlaceholder: string,
  dropdownLabel: string,
  dropdownOptions: Array<string>,
  validationEnabled: boolean,
  validate: Function,
  isMobile: boolean,
  renderLeftIcon: React$Component
}

class FormDropdown extends Component<Props> {
  static defaultProps = {
    dropdownOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'],
    validationEnabled: true,
    dropdownPlaceholder: 'Ex : 1',
    dropdownLabel: 'No. of People',
    isBhowaniporePresentInQueryParams: false
  }
  constructor(props) {
    super(props)
    this.state = {
      dropdownValue: props.dropdownOptions[0],
      dropdownExpanded: false,
      displayError: false,
      errorMsg: 'Please select option'
    }
  }

  setError = error => {
    this.setState({ errorMsg: error })
  }

  setDisplayError = displayError => {
    this.setState({ displayError })
  }

  validate = response => {
    if (response.displayError) {
      this.setError(response.errorMsg)
    }
    this.setDisplayError(response.displayError)
  }

  reset = () => {
    this.setState({
      dropdownValue: this.props.dropdownOptions[0],
      dropdownExpanded: false,
      displayError: false,
      errorMsg: 'Please select option'
    })
  }

  validateDropDownValue = () => {
    let { validationEnabled, validate } = this.props
    let { dropdownValue } = this.state
    if (validationEnabled) {
      if (validate) {
        this.validate(validate(dropdownValue))
      }
    }
  }

  setSelectedValue = dropdownOption => {
    this.setState({ dropdownValue: dropdownOption })
    this.dropdownRef.instanceRef.toggleDropDown()
    this.validateDropDownValue()
  }

  renderDropDownButtonComponent = () => {
    let { dropdownValue, dropdownExpanded } = this.state
    let {
      dropdownPlaceholder,
      isMobile,
      renderLeftIcon,
      isBhowaniporePresentInQueryParams
    } = this.props
    let strokeColor = Colors.blueyGreyThree
    if (dropdownExpanded) {
      strokeColor = Colors.twilightBlueTwo
    }
    return (
      <DropdownButton
        expanded={dropdownExpanded}
        isBhowaniporePresentInQueryParams={isBhowaniporePresentInQueryParams}
      >
        {renderLeftIcon || (
          <DropdownLeftIcon>
            <LeftIcon width={15} height={12} strokeColor={strokeColor} />
          </DropdownLeftIcon>
        )}
        <DropdownValue
          expanded={dropdownExpanded}
          placeholder={dropdownValue}
          isMobile={isMobile}
        >
          {dropdownValue || dropdownPlaceholder}
        </DropdownValue>
        <DropdownDownArrow>
          <DownArrow width={10} height={6} fillColor="#89929f" />
        </DropdownDownArrow>
      </DropdownButton>
    )
  }

  renderDropdownOptions = dropdownOptions =>
    dropdownOptions.map(dropdownOption => (
      <DropdownText onClick={() => this.setSelectedValue(dropdownOption)}>
        {dropdownOption}
      </DropdownText>
    ))

  setDropdownExpanded = dropdownExpanded => {
    this.setState({ dropdownExpanded })
  }
  onPressDropdown = () => {
    scrollToDesktopSBFormDropdown()
  }

  onMouseEnter = () => {
    disableScroll()
  }

  onMouseLeave = () => {
    enableScroll()
  }

  render() {
    const {
      dropdownOptions,
      dropdownLabel,
      isMobile,
      isBhowaniporePresentInQueryParams
    } = this.props
    const { errorMsg, displayError } = this.state
    const dropDownOptionsLength = dropdownOptions.length
    return (
      <MainContainer
        id={this.props.id}
        isBhowaniporePresentInQueryParams={isBhowaniporePresentInQueryParams}
      >
        <DropdownLabel
          id="dropdown_label"
          displayError={displayError}
          isMobile={isMobile}
        >
          {dropdownLabel}
        </DropdownLabel>
        <Dropdown
          ref={dropdownRef => {
            this.dropdownRef = dropdownRef
          }}
          buttonComponent={this.renderDropDownButtonComponent()}
          getDropdownState={dropdownExpanded => {
            this.setDropdownExpanded(dropdownExpanded)
          }}
          dropdownMainContainerStyles={styles.dropdownStyles}
          onPressDropdown={this.onPressDropdown}
        >
          <DropdownOptionsContainer
            className="custom-scroll-bar"
            dropDownOptionsLength={dropDownOptionsLength}
          >
            {this.renderDropdownOptions(dropdownOptions)}
          </DropdownOptionsContainer>
        </Dropdown>
        {displayError ? <DropdownError>{errorMsg}</DropdownError> : null}
      </MainContainer>
    )
  }
}

export default FormDropdown



// WEBPACK FOOTER //
// ./src/components/IbcArcade/FormDropdown/index.js